var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0005 6.32422V18.3242H6.00049V6.32422H18.0005ZM11.0512 9.32422H9.88257L7.6638 15.3242H8.71814L9.13704 14.1513H11.7931L12.203 15.3242H13.3208L11.0512 9.32422ZM15.1924 9.32422H14.1423V15.3242H15.1924V9.32422ZM10.4581 10.3309L11.504 13.3242H9.42869L10.4581 10.3309ZM19.0005 15.3242H21.0005V17.3242H19.0005V15.3242ZM7.00049 19.3242H9.00049V21.3242H7.00049V19.3242ZM11.0005 19.3242H13.0005V21.3242H11.0005V19.3242ZM7.00049 3.32422H9.00049V5.32422H7.00049V3.32422ZM15.0005 19.3242H17.0005V21.3242H15.0005V19.3242ZM11.0005 3.32422H13.0005V5.32422H11.0005V3.32422ZM15.0005 3.32422H17.0005V5.32422H15.0005V3.32422ZM19.0005 11.3242H21.0005V13.3242H19.0005V11.3242ZM3.00049 15.3242H5.00049V17.3242H3.00049V15.3242ZM19.0005 7.32422H21.0005V9.32422H19.0005V7.32422ZM3.00049 11.3242H5.00049V13.3242H3.00049V11.3242ZM3.00049 7.32422H5.00049V9.32422H3.00049V7.32422Z",
    fill: "#5D2EDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiSvgrepoCom1);
export default __webpack_public_path__ + "static/media/ai-svgrepo-com 1.28dd4ee1bc1135d0a9e405f9d43f1cac.svg";
export { ForwardRef as ReactComponent };